<template>
  <div class="viewproject-step1">
    <h3 class="page-title mb-8 mt-1">О проекте</h3>
    <div class="profile-item-title">Краткое описание проекта</div>
    <div class="profile-item-value">
      <v-textarea :value="curProject.description" @input="onInput('description', $event)"
          :error-messages="fieldErrors('description')" outlined dense no-resize _hide-details rows="5"
      />
    </div>

    <div class="profile-item-title">Продолжительность проекта</div>
    <div class="profile-item-value">
      <v-menu v-model="datePickerShow" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="range.join(' - ')"
            append-icon="mdi-calendar" :prepend-inner-icon="range.length ? 'mdi-close' : null"
            @click:prepend-inner="clearRange"
            class="project-range font-sm" dense readonly outlined hide-details
            v-bind="attrs" v-on="on"
          />
        </template>
        <v-date-picker v-model="range" dense range no-title scrollable locale="ru-RU">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cancelRange"> Отменить </v-btn>
          <v-btn text color="primary" @click="applyRange" :disabled="range.length !== 2"> OK </v-btn>
        </v-date-picker>
      </v-menu>
    </div>

    <ProjectStep2 hideControls class="mt-4"/>

  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import ProjectStep2 from './ProjectStep2.vue';

export default {
  name: 'AIPage',
  components: {
    ProjectStep2
  },
  props:{
  },
  data() {
    return {
      datePickerShow: false,
      datePickerDateFormat: 'DD-MM-YYYY',
      range: [],
    };
  },
  computed: {
    ...mapGetters({
      curProject: 'ai/hrprojects/curProject',
      loading: 'ai/hrprojects/loading',
    }),
  },
  methods: {
    onInput() {

    },
    fieldErrors() {

    },
    clearRange() {
      this.range = [];
      this.datePickerShow = false;
    },
    cancelRange() {
      if (this.curProject.date_from && this.curProject.date_to) {
        this.range = [this.curProject.date_from, this.curProject.date_to];
      } else {
        this.range = [];
      }
      this.datePickerShow = false;
    },
    applyRange() {
      this.range = this.range.sort((a, b) =>
        this.$moment(a, this.datePickerDateFormat).isBefore(this.$moment(b, this.datePickerDateFormat)) ? -1 : 1
      );
      // this.setFilterRange(this.range);
      this.datePickerShow = false;
    },
    next() {
      this.$emit('next')
    },
  }
};
</script>

<style lang="scss" scoped>

.viewproject-step1 {
  width: 1200px;
  max-width: 100%;
}

.project-range {
  width: 300px; 
  max-width: 100%;

}
</style>

